// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2150":"css/app.6729","2851":"css/admin-app.6729"}[chunkId] + ".css";
};